import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, Tooltip } from '@mui/material';

import { showDownloadsDialog } from '../../../store/actions/popupActions';
import { getDownloadingEnabledSelector } from '../../../store/selectors/downloadSelectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function DownloadButton({ condensed }: { condensed?: boolean }) {
  const dispatch = useAppDispatch();
  const downloadingEnabled = useAppSelector(getDownloadingEnabledSelector);

  const handleClick = () => {
    dispatch(showDownloadsDialog());
  };

  const title = 'Download files (Ctrl + Shift + D)';
  const icon = <DownloadIcon />;

  return condensed ? (
    <ToolbarIconButton title={title} icon={icon} onClick={handleClick} />
  ) : (
    <Tooltip title={title}>
      <span>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={handleClick}
          startIcon={icon}
          aria-label={title}
          disabled={!downloadingEnabled}
        >
          Download
        </Button>
      </span>
    </Tooltip>
  );
}
